import moment from "moment-timezone";
import { TIMEZONE } from "../Constant";
// import { TIMEZONE } from "../constants/constants";

export function fDate(date) {
  if (!date) return null;
  return moment(date).format("DD MMM, yyyy");
}

export function fDateTime(date) {
  if (!date) return null;
  return moment(date).format("DD MMM yyyy, hh:mm a");
}

export function fTimestamp(date) {
  if (!date) return null;
  return moment(date).toDate();
}

export function fDateTimeDuration(start, end) {
  if (!moment(start).isValid() || !moment(end).isValid()) return null;
  return moment(end).to(moment(start), true);
}

export function fTime12(date) {
  if (!date) return null;
  return moment(date).format("hh:mm a");
}

export function fTime24(date) {
  if (!date) return null;
  return moment(date, "HH:mm:ss").format("HH:mm");
}

export function fDurations(minutes) {
  const _hours = Math.floor(minutes / 60);
  const _minutes = minutes % 60;

  return {
    hours: Number.isInteger(_hours) ? _hours : 0,
    minutes: Number.isInteger(_minutes) ? _minutes : 0,
  };
}

// Function to get time in EST (using device's time zone)
export function fESTTime(date, timezone) {
  if (!date) return null;
  let deviceTimeZone = timezone || moment.tz.guess();
  return moment.tz(date, deviceTimeZone).format("hh:mm a");
}


export function fESTDate(date, timezone, format = "") {
  if (!date) return null;
  let deviceTimeZone = timezone || moment.tz.guess();
  return moment.tz(date, deviceTimeZone).format(format || "DD MMM YYYY");
}

export const convertDateTimeToTz = (dateTime, tz, f = null) => {
  if(!tz){
      tz=  TIMEZONE["America/Toronto"];
  }
  const time = moment(dateTime).tz(tz)
  if (f) return time.format(f);
  return time;
};

export const convertDateTimeToTzUTC = (dateTime, tz, f = 'YYYY-MM-DDTHH:mm:ss.000Z') => {
  const time = moment.tz(dateTime, tz).utc()
  if (f) return time.format(f);
  return time.format();
};

export function localizeDateTime(date, timezone) {
  if (!date) return null;
  let deviceTimeZone = timezone || moment.tz.guess();
  const localizedDate = moment.tz(date, deviceTimeZone);
  const now = moment.tz(deviceTimeZone);

  if (localizedDate.isSame(now, "day")) {
    return `Today at ${localizedDate.format("hh:mm a")}`;
  } else if (localizedDate.isSame(now.subtract(1, "day"), "day")) {
    return `Yesterday at ${localizedDate.format("hh:mm a")}`;
  } else if (localizedDate.isSame(now, "week")) {
    return `${localizedDate.format("dddd")} at ${localizedDate.format("hh:mm a")}`;
  } else {
    return `${localizedDate.format("DD MMM YYYY")} at ${localizedDate.format("hh:mm a")}`;
  }
}

export const getTimeZoneAbbreviation = (timezone) => {
  return moment.tz(timezone).format('z');
};

export const currentDateInTz = (date, timezone) => {
    if (!timezone) {
        timezone = 'America/Toronto';
    }
    const currentTimeInEDT = moment.tz(timezone).format('HH:mm:ss');
    const dateTime = moment.tz(`${date}T${currentTimeInEDT}`, 'YYYY-MM-DDTHH:mm:ss', timezone);
    return dateTime;
}

export const convertCutoffTimeToTz = (dateTime, fromTz, toTz, f = null) => {
    if (!fromTz) {
        fromTz = 'America/Toronto';
    }

    const time = moment.tz(dateTime, fromTz).tz(toTz);
    if (f) return time.format(f);
    return time;
};


export function fDateUTC(date) {
  if (!date) return null;
  return moment.utc(date).format("DD MMM YYYY");
}


